import React, {useState} from 'react';

import {assert} from 'Asserts';
import SelectTemplateCollectionItemTree from 'notebook/entry-templates/SelectTemplateCollectionItemTree/SelectTemplateCollectionItemTree';
import {ButtonStyle} from 'ui-library/buttons/Button';
import Modal from 'ui-library/modals/Modal';

interface ModalProps {
  onRequestClose: () => void;
  onRequestSubmit: (subtemplateId: string) => void;
}

function InsertSubtemplateModal(props: ModalProps): JSX.Element {
  const [subtemplateId, setSubtemplateId] = useState<string | null>(null);

  return (
    <Modal
      title="Select sub-template"
      onRequestClose={props.onRequestClose}
      onRequestSubmit={() => {
        assert(
          typeof subtemplateId === 'string' && Boolean(subtemplateId),
          'subtemplateId should be a non-empty string'
        );
        props.onRequestSubmit(subtemplateId);
      }}
      buttons={[
        {
          text: 'Insert',
          style: ButtonStyle.SECONDARY,
          submit: true,
          disabled: !subtemplateId,
        },
      ]}
    >
      <SelectTemplateCollectionItemTree
        collectibleType="SUB-TEMPLATE"
        collectibleId={subtemplateId}
        setCollectible={(subtemplate) => {
          setSubtemplateId(subtemplate?.id || null);
        }}
        autoFocus={true}
      />
    </Modal>
  );
}

export default InsertSubtemplateModal;
